import React from 'react';
import { inject, observer } from 'mobx-react';
import { action, observable, toJS } from 'mobx';
// import Form, { SelectInput } from '../../../Form';
import FormMultiSelectInput from "../../../FormMultiSelectInput";

@inject('userStore', 'ticketStore', 'rolePermissionStore')
@observer
export default class TicketFollower extends React.Component {
  @observable searchTags = [];
  @observable multiUserOptions = [];
  @observable addFollower = false;

  componentDidMount() {
    const { userStore, ticketStore } = this.props;

    if (userStore.items && userStore.items.length > 0) {
      if (this.multiUserOptions.length === 0) {
        const newMultiUserOptions = userStore.items.map(item => ({
          id: item.id,
          name: item.name,
          email: item.email,
          label: item.name + (!item.email ? '' : `(${item.email})`),
          value: !!ticketStore.followers.find(follower => +follower.user_id === +item.id)
        }));

        this.multiUserOptions = newMultiUserOptions;
        this.onChangeSearchTags(newMultiUserOptions.filter(item => !!item.value).map(item => item.name));
      }
    }
  }

  onToggleAddFollower = () => this.addFollower = !this.addFollower;

  onAddFollower = user => {
    const { ticketStore, ticket_id } = this.props;
    ticketStore.addTicketFollower(ticket_id, user);
  };

  onRemoveFollower = user_id => {
    const { ticketStore, ticket_id } = this.props;
    ticketStore.removeTicketFollower(ticket_id, user_id);
    this.multiUserOptions.find(item => +item.id === +user_id).value = false;
  };

  onUserSelect = (item) => {
    item.value = !item.value;

    if (item.value) {
      this.onAddFollower({
        user_id: item.id,
        name: item.name,
        email: item.email,
      });
    } else {
      this.onRemoveFollower(item.id);
    }

    this.onChangeSearchTags(this.multiUserOptions.filter(item => !!item.value).map(item => item.name))
  }

  @action onChangeSearchTags = tags => {
    this.searchTags = tags;
  }

  render() {
    const { ticketStore, rolePermissionStore } = this.props;
    const hasUserPermission = rolePermissionStore.validateRole('view user');
    // let ticketFollowers = ticketStore.followers.map(follower => follower.user_id);
    // let availableUsers = userStore.items.filter(user => ticketFollowers.indexOf(user.id) === -1);

    return (
      <div className='ticket-follower'>
        <div className='DataTable'>
          <table>
            <thead style={{ color: this.addFollower ? "black" : "white" }}>
              <tr>
                <th>{ }</th>
                <th>{this.addFollower ?
                  <FormMultiSelectInput id='user-multi-select' label='' options={this.multiUserOptions} optionClicked={item => this.onUserSelect(item)} loading={false} hideSelectAll hideClearAll /> :
                  `Followers (${ticketStore.followers.length})`
                }</th>
                {hasUserPermission && <th className='crudActions'>
                  <a onClick={this.onToggleAddFollower}><i className={this.addFollower ? 'fa fa-remove' : 'fa fa-plus'} /></a>
                </th>}
              </tr>
            </thead>
            <tbody>{ticketStore.followers.map((item, index) => {
              return (
                <tr key={`user_${item.user_id}_${index}`}>
                  <td width="20"><input type='checkbox' checked={item.checked} onChange={() => item.checked = !item.checked} /></td>
                  <td data-toggle="tooltip" title={item.email}>{item.name}</td>
                  {hasUserPermission && <td className='crudActions'>
                    <a onClick={() => this.onRemoveFollower(item.user_id)}><i className='fa fa-remove' /></a>
                  </td>}
                </tr>
              )
            })}</tbody>
          </table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/Followers/TicketFollower.js